import * as React from 'react';
import { useState } from 'react';

import { ActivityType } from '@showbie-socrative/socrative-utils';
import { translate } from '~l10n/client';

import { SmallButton } from '~shared/components/buttons';
import { IconDownload } from '~shared/components/icons/standard';
import { AssessmentsExportReports } from '~teacher/components/ExportReports/Assessments/AssessmentsExportReports';
import { PaywallProvider } from '~teacher/components/PaywallDialog';
import { ActivitySettingsCamelCase } from '~teacher/models/activities';

import { ResultsHeader } from '../ResultsHeader';
import { QuizResultsHeaderContainer } from './QuizResultsHeaderContainer';

interface QuizResultsHeaderSansControlsProps {
  title: string;
  quizStandard?: string;
  startDate: string;
  endDate: string;
  activityInstanceId: number;
  activityType: ActivityType;
  activitySettings: ActivitySettingsCamelCase;
}

export function QuizResultsHeaderSansControls({
  title,
  quizStandard,
  startDate,
  endDate,
  activityInstanceId,
  activityType,
  activitySettings,
}: QuizResultsHeaderSansControlsProps) {
  const [showExportReportsModal, setShowExportReportsModal] = useState(false);

  return (
    <PaywallProvider>
      <QuizResultsHeaderContainer>
        <ResultsHeader
          title={title}
          standard={quizStandard}
          startDate={startDate}
          endDate={endDate}
          activitySettings={activitySettings}
        >
          {endDate && (
            <SmallButton
              appearance="text"
              isDisabled={activityType === ActivityType.NoReport}
              onClick={() => setShowExportReportsModal(true)}
            >
              <IconDownload />
              {translate('Export')}
            </SmallButton>
          )}
        </ResultsHeader>
      </QuizResultsHeaderContainer>
      <AssessmentsExportReports
        open={showExportReportsModal}
        onClose={() => setShowExportReportsModal(false)}
        activityInstanceId={activityInstanceId}
        activityType={activityType}
      />
    </PaywallProvider>
  );
}
